export default __webpack_public_path__ + "static/media/Divyanshi-saini.2bdcc756.jpeg";